var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "15",
        height: "14",
        viewBox: "0 0 15 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { id: "Icon / CloseOutlined" } }, [
        _c("path", {
          attrs: {
            id: "Vector",
            d: "M8.20831 7L11.7972 2.72207C11.8573 2.65098 11.8067 2.54297 11.7138 2.54297H10.6228C10.5585 2.54297 10.497 2.57168 10.4546 2.6209L7.49464 6.14961L4.53468 2.6209C4.49366 2.57168 4.43214 2.54297 4.36652 2.54297H3.2755C3.18253 2.54297 3.13195 2.65098 3.1921 2.72207L6.78097 7L3.1921 11.2779C3.17863 11.2938 3.16998 11.3132 3.16719 11.3338C3.1644 11.3544 3.16759 11.3754 3.17637 11.3942C3.18515 11.4131 3.19916 11.429 3.21673 11.4402C3.2343 11.4513 3.2547 11.4571 3.2755 11.457H4.36652C4.43077 11.457 4.4923 11.4283 4.53468 11.3791L7.49464 7.85039L10.4546 11.3791C10.4956 11.4283 10.5571 11.457 10.6228 11.457H11.7138C11.8067 11.457 11.8573 11.349 11.7972 11.2779L8.20831 7Z",
            fill: "black",
            "fill-opacity": "0.45",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }